<template>
<div class="login">
  <div class="main-inner">
    <main>
      <!-- .radius-box.white-box.row -->
      <section v-if="!mailSent" class="radius-box white-box row">
        <h2 class="login-pagetitle">パスワード再設定</h2>
        <form action="/">
          <ul class="login-form">
            <li>
              <input :type="inputType1" name="newPassword" v-model="newPassword" placeholder="新しいパスワード" class="input">
                <span class="input-icon">
                  <span :class="iconType1" @click="onClick1"><img class="password-icon" src="../../../static/icon_login.png"></span>
                </span>
              <div v-if="submitted && !$v.newPassword.required" class="text-error"><small>パスワードを入力してください。</small></div>
              <div v-if="submitted && $v.newPassword.required && !$v.newPassword.validatePsw" class="text-error"><small>パスワードのフォーマットに誤りがあります。</small></div>
            </li>
            <li>
              <input :type="inputType2" v-model="newPasswordConfirm" name="newPasswordConfirm" placeholder="新しいパスワード（確認）" class="input">
                <span class="input-icon">
                  <span :class="iconType2" @click="onClick2"><img class="password-icon" src="../../../static/icon_login.png"></span>
                </span>
              <div v-if="submitted && !$v.newPasswordConfirm.sameAsNewPassword" class="text-error"><small>パスワードが間違っています。</small></div>
            </li>
            <li v-if="displayErrorMessage" class="text-error"><small>{{ errorMessage }}</small></li>
            <li class="btn-gray2"><button @click.prevent="sendBtnClick">再設定</button></li>
          </ul>
        </form>
      </section>
      <section v-if="mailSent" class="radius-box white-box row">
        <h2 class="login-pagetitle">パスワードの再設定が完了しました</h2>
        <p>ご登録のメールアドレス宛にパスワード再設定完了メールをお送りしました。</p>
        <p>24時間を経過してもパスワード再設定完了メールが届かない場合は、お手数ですが、お問い合わせフォームからお問い合わせいただきますよう、お願いいたします。</p>
        <br>
        <div class = "btn-set">
          <a href="/corp_admin/login" class="btn-gray2"><button>ログインへ戻る</button></a>
        </div>
      </section>
    </main>
  </div>
</div>
</template>

<script>
import httpResource from '../../http/httpResource'
import { required, sameAs } from 'vuelidate/lib/validators'
import { validatePsw } from '../../util/validation'
export default {
  name: 'ResetPasswordInput',
  data () {
    return {
      newPassword: null,
      newPasswordConfirm: null,
      submitted: false,
      isChecked1: false,
      isChecked2: false,
      displayErrorMessage: false,
      errorMessage: '',
      mailSent: false
    }
  },
  beforeCreate: function () {
    document.body.className = 'login'
  },
  beforeMount: function () {
    this.checkValidToken()
  },
  validations: {
    newPassword: {
      required,
      validatePsw
    },
    newPasswordConfirm: {
      sameAsNewPassword: sameAs('newPassword')
    }
  },
  computed: {
    inputType1: function () {
      return this.isChecked1 ? 'text' : 'password'
    },
    iconType1: function () {
      return this.isChecked1 ? 'eye' : 'eye-slash'
    },
    inputType2: function () {
      return this.isChecked2 ? 'text' : 'password'
    },
    iconType2: function () {
      return this.isChecked2 ? 'eye' : 'eye-slash'
    }
  },
  methods: {
    async checkValidToken () {
      try {
        await httpResource.get('/corporation/reset-password/' + this.$route.params.token)
      } catch (error) {
        this.$router.push({name: 'ログイン'})
      }
    },
    onClick1 () {
      this.isChecked1 = !this.isChecked1
    },
    onClick2 () {
      this.isChecked2 = !this.isChecked2
    },
    async sendBtnClick () {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const changePasswordForm = {
        newPassword: this.newPassword,
        newPasswordConfirm: this.newPasswordConfirm
      }
      try {
        const response = await httpResource.post('/corporation/reset-password/' + this.$route.params.token, changePasswordForm)
        if (response.status === 200) {
          console.log(response)
          if (response.data.message === 'SUCCESS') {
            this.mailSent = true
          } else if (response.data.message === 'password') {
            this.displayErrorMessage = true
            this.errorMessage = '入力されたパスワードは使われています。'
          } else if (response.data.message === 'token') {
            this.displayErrorMessage = true
            this.errorMessage = '使用できないトークン情報です。'
          }
        }
      } catch (error) {
        this.$router.push({name: 'ログイン'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reset-password/input.vue